import { startOfWeek, differenceInCalendarWeeks } from 'date-fns';

// Référence : la semaine du 29/06/2026 (lundi) = semaine A
const REFERENCE_MONDAY = new Date(2026, 5, 29); // mois 0-indexé : juin = 5
const CYCLE = ['A', 'B', 'C', 'D'];

export default function useWeekType(date) {
    const monday = startOfWeek(date, { weekStartsOn: 1 });
    const refMonday = startOfWeek(REFERENCE_MONDAY, { weekStartsOn: 1 });

    const diffWeeks = differenceInCalendarWeeks(monday, refMonday, { weekStartsOn: 1 });

    // Modulo qui gère aussi les diffs négatives (semaines avant la référence)
    const index = ((diffWeeks % 4) + 4) % 4;

    return CYCLE[index];
}